import { useState } from "react";
import { AbstructVar } from "../../general/general-component/abstruct-component/AbstructVar";

export const VariableCreativeWorkRequests = () => {
    let { navigate } = AbstructVar();

    const [state, setState] = useState({
        status: "",
        date_from: "",
        date_to: "",
        creative_work_type_id: null,
        visitor_id: null,
        creativeWork: {
            id: null,
            source: "",
            title: "",
            duration_minutes: 0,
            episodes_count: 0,
            status: "",
            workType: {
                id: null,
                name: "",
                type: "",
                created_at: "",
                updated_at: "",
            },
            summaries: [
                {
                    id: null,
                    file_path: "",
                    description: "",
                    episode_number: "",
                    creative_work_id: null,
                    created_at: "",
                    updated_at: "",
                },
            ],
            notes: [],
            visitor: {
                id: null,
                first_name: "",
                last_name: "",
                phone_number: "",
                email: "",
                created_at: "",
                updated_at: "",
            },
            averageDegree: null,
            created_at: "",
        },
        Load: false, // Added Load property
        open: false, // Added open property
        openEdit: false, // Added openEdit property
    });

    const setStateCustom = (variableName, value) => {
        console.log(value);
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };

    const setLoad = (value) => {
        console.log(value);
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };

    const setOpen = (value) => {
        console.log(value);
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };

    const setopenEdit = (value) => {
        console.log(value);
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };

    const handleEdit = (event, arr) => {
        event.preventDefault();
        navigate(`/project-request/${arr.id}`, { state: { arr } });
    };

    const handleEvaluationDetails = (event, arr) => {
        event.preventDefault();
        navigate(`/project-request/${arr.id}/details`, { state: { arr } });
    };

    return {
        ...state,
        state,
        setState,
        handleEdit,
        handleEvaluationDetails,
        setOpen,
        setopenEdit,
        setStateCustom,
        setLoad,
    };
};
